export const TAWK_ACCOUNT_KEY = process.env.REACT_APP_TAWK_ACCOUNT_KEY
  ? process.env.REACT_APP_TAWK_ACCOUNT_KEY
  : "";
export const TAWK_ID = process.env.REACT_APP_TAWK_ID
  ? process.env.REACT_APP_TAWK_ID
  : "";
